export enum MapType {
    WORLD_MAP = 'WORLD_MAP',
    REGION = 'REGION',
    MAP = 'MAP',
    DUNGEON = 'DUNGEON',
    TRIAL = 'TRIAL',
    RAID8 = 'RAID8',
    RAID24 = 'RAID24',
    OTHER = 'OTHER',
}